import styles from './downloadPdf.module.scss';
import SiteLink from '../../shared/sitelink';

const DownloadPdf = ({ data }) => {
  const { linkText, pdfUrl } = data;

  return (
    <section id="sectionDownloadPdf">
      <div className={styles.titleAndTextWrapper}>
        <SiteLink external={pdfUrl} className={styles.downloadAnchor}>
          {linkText}
        </SiteLink>
      </div>
    </section>
  );
};

export default DownloadPdf;
